import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=dec25ace&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=dec25ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec25ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec25ace')) {
      api.createRecord('dec25ace', component.options)
    } else {
      api.reload('dec25ace', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=dec25ace&scoped=true&", function () {
      api.rerender('dec25ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2btxGZi0FcoWy/JS/comp/SearchFilterTokens.vue"
export default component.exports